/* prettier: { "printWidth": 200 } */

const env = {
  AWS: {
    S3: {
      UsesPathPrefixInsteadOfSubDomain: 'env__aws__s3__uses_path_prefix_instead_of_sub_domain',
      Region: 'env__aws__s3__region',
      AccessKeyId: 'env__aws__s3__access_key_id',
      AccessSecretKey: 'env__aws__s3__access_secret_key',
      BucketName: 'env__aws__s3__bucket_name',
      Domain: 'env__aws__s3__domain',
      ClientBucketName: 'env__aws__s3__client_bucket_name',
    },
    Cognito: {
      UseNicknameAsIdentifier: 'env__aws__cognito__use_nickname_as_identifier',
      Region: 'env__aws__cognito__region',
      AccessKeyId: 'env__aws__cognito__access_key_id',
      AccessSecretKey: 'env__aws__cognito__access_secret_key',
      UserPoolID: 'env__aws__cognito__user_pool_id',
      ClientID: 'env__aws__cognito__client_id',
      ClientSecret: 'env__aws__cognito__client_secret',
    },
    SES: {
      Region: 'env__aws__ses__region',
      AccessKeyId: 'env__aws__ses__access_key_id',
      AccessSecretKey: 'env__aws__ses__access_secret_key',
      SenderName: 'env__aws__ses__sender_name',
      SenderEmail: 'env__aws__ses__sender_email',
    },
    DynamoDB: {
      Region: 'env__aws__dynamodb__region',
      AccessKeyId: 'env__aws__dynamodb__access_key_id',
      AccessSecretKey: 'env__aws__dynamodb__access_secret_key',
      Tables: {
        SingleProduct: 'env__aws__dynamodb__tables__single_product',
      },
    },
  },
  Firebase: {
    Common: {
      ProjectId: 'env__firebase__common__project_id',
      ProjectKeyId: 'env__firebase__common__project_key_id',
      AppId: 'env__firebase__common__app_id',
      ApiKey: 'env__firebase__common__api_key',
      PrivateKey: 'env__firebase__common__private_key',
      ClientEmail: 'env__firebase__common__client_email',
      ClientId: 'env__firebase__common__client_id',
    },
    Analytics: {
      Enabled: 'env__firebase__analytics__enabled',
      MeasurementId: 'env__firebase__analytics__measurement_id',
    },
    RealtimeDatabase: {
      Region: 'env__firebase__realtime_database__region',
      Name: 'env__firebase__realtime_database__name',
    },
    RemoteConfig: {},
    CloudMessaging: {
      SenderId: 'env__firebase__cloud_messaging__sender_id',
    },
  },
  Map: {
    GoogleMap: {
      API: {
        ApiKey: 'env__map__google_map__api__api_key',
      },
      Client: {
        ApiKey: 'env__map__google_map__client__api_key',
      },
    },
    YandexMap: {
      Client: {
        ApiKey: 'env__map__yandex_map__client__api_key',
      },
      API: {
        GeocoderHttp: {
          ApiKey: 'env__map__yandex_map__api__geocoder_http__api_key',
        },
        GeoSuggest: {
          ApiKey: 'env__map__yandex_map__api__geo_suggest__api_key',
        },
      },
    },
  },
  Delivery: {
    HayPost: {
      API: {
        Username: 'env__delivery__hay_post__api__username',
        Password: 'env__delivery__hay_post__api__password',
        CustomerID: 'env__delivery__hay_post__api__customer_id',
      },
    },
    MegaMove: {
      API: {
        Username: 'env__delivery__mega_move__api__username',
        Password: 'env__delivery__mega_move__api__password',
      },
      Vendor: {
        TokenSignature: 'env__delivery__mega_move__vendor__token_signature',
        Username: 'env__delivery__mega_move__vendor__username',
        Password: 'env__delivery__mega_move__vendor__password',
      },
    },
    ZZLogistics: {
      API: {
        User: {
          FirstName: 'env__delivery__zzlogistics__api__user__first_name',
          LastName: 'env__delivery__zzlogistics__api__user__last_name',
          Email: 'env__delivery__zzlogistics__api__user__email',
          Password: 'env__delivery__zzlogistics__api__user__password',
        },
      },
      Vendor: {
        AccessToken: 'env__delivery__zzlogistics__vendor__access_token',
      },
    },
    Yandex: {
      API: {
        AuthToken: 'env__delivery__yandex__api__auth_token',
      },
    },
    CustomDelivery: {
      DeliveryCost: 'env__delivery__custom_delivery__delivery_cost',
      FreeAfterAmount: 'env__delivery__custom_delivery__free_after_amount',
    },
  },
  Payment: {
    IDBank: {
      IsTesting: 'env__payment__id_bank__is_testing',
      Api: {
        Username: 'env__payment__id_bank__api__username',
        Password: 'env__payment__id_bank__api__password',
      },
      Binding: {
        Username: 'env__payment__id_bank__binding__username',
        Password: 'env__payment__id_bank__binding__password',
      },
    },
    IDram: {
      ReceiverAccount: 'env__payment__idram_receiver_account',
      SecretKey: 'env__payment__idram_secret_key',
    },
    AmeriaBank: {
      IsTesting: 'env__payment__ameria_bank__is_testing',
      ClientID: 'env__payment__ameria_bank__client_id',
      Username: 'env__payment__ameria_bank__username',
      Password: 'env__payment__ameria_bank__password',
      TwoStepFreeze: 'env__payment__ameria_bank__two_step_freeze',
      TestRange: {
        Start: 'env__payment__ameria_bank__test_range__start',
        End: 'env__payment__ameria_bank__test_range__end',
      },
    },
    Yookassa: {
      Username: 'env__payment__yookassa__username',
      Password: 'env__payment__yookassa__password',
    },
    YumGo: {
      IsTesting: 'env__payment__yum_go__is_testing',
      Username: 'env__payment__yum_go__username',
      Password: 'env__payment__yum_go__password',
      PublicKey: 'env__payment__yum_go__public_key',
      PrivateKey: 'env__payment__yum_go__private_key',
      ServiceName: 'env__payment__yum_go__service_name',
    },
    Stripe: {
      OpenWidgetInsteadOfRedirect: 'env__payment__stripe__open_widget_instead_of_redirect',
      PublishableKey: 'env__payment__stripe__publishable_key',
      SecretKey: 'env__payment__stripe__secret_key',
    },
    Click: {
      MerchantId: 'env__payment__click__merchant_id',
      MerchantUserId: 'env__payment__click__merchant_user_id',
      ServiceId: 'env__payment__click__service_id',
      SecretKey: 'env__payment__click__secret_key',
    },
  },
  ProductSource: {
    Providers: 'env__product_source__providers',
    ProviderConfigs: {
      Ali1688: {
        AppKey: 'env__product_source__provider_configs_ali1688__app_key',
        AppSecret: 'env__product_source__provider_configs_ali1688__app_secret',
        AccessToken: 'env__product_source__provider_configs_ali1688__access_token',
        Categories: 'env__product_source__provider_configs_ali1688__categories',
        Country: 'env__product_source__provider_configs_ali1688__country',
        Language: 'env__product_source__provider_configs_ali1688__language',
        SellerInfo: {
          Email: 'env__product_source__provider_configs_ali1688__seller_info__email',
          Phone: 'env__product_source__provider_configs_ali1688__seller_info__phone',
        },
      },
      Billz: {
        SecretToken: 'env__product_source__provider_configs__billz__secret_token',
        LastSyncedAt: 'env__product_source__provider_configs__billz__last_synced_at',
      },
    },
  },
  AI: {
    OpenAI: {
      ApiKey: 'env__ai__open_ai__api_key',
      Model: 'env__ai__open_ai__model',
    },
    UsageLimit: {
      ProductSuggestion: 'env__ai__usage_limit__product_suggestion',
    },
  },
  LegalInfo: {
    DaData: {
      AuthToken: 'env__legal_info__da_data__auth_token',
    },
  },
  MobileApp: {
    ForceUpdateVersionIfLessThen: 'env__mobile__app__force__update__version__if__less__then',
  },
  PlatformSettings: {
    PrerenderEnabled: 'env__platform_settings__prerender_enabled',
    HomePageProductsCount: 'env__platform_settings__home_page_products_count',
    ProductPriceIncreasePercent: 'env__platform_settings__product_price_increase_percent',
    YandexExpressDeliveryAdditionalCost:
      'env__platform_settings__yandex_express_delivery_additional_cost',
    Admin: {
      CategoryForm: {
        RadioFormFieldValuesLimit:
          'env__platform_settings__admin__category_form__radio_form_field_values_limit',
      },
    },
    Seller: {
      ProductCreation: {
        VariationValuesLimit:
          'env__platform_settings__seller__product_creation__variation_values_limit',
      },
    },
  },
  BranchIO: {
    LiveKey: 'env__branch_io__live_key',
    TestKey: 'env__branch_io__test_key',
  },
  Tracking: {
    Admin: {
      GoogleTag: 'env__tracking__admin__google_tag',
      GoogleAnalyticsMeasurementId: 'env__tracking__admin__google_analytics_measurement_id',
      MetaPixel: 'env__tracking__admin__meta_pixel',
    },
    Seller: {
      GoogleTag: 'env__tracking__seller__google_tag',
      GoogleAnalyticsMeasurementId: 'env__tracking__seller__google_analytics_measurement_id',
      MetaPixel: 'env__tracking__seller__meta_pixel',
    },
    WebApp: {
      GoogleTag: 'env__tracking__webapp__google_tag',
      GoogleAnalyticsMeasurementId: 'env__tracking__webapp__google_analytics_measurement_id',
      MetaPixel: 'env__tracking__webapp__meta_pixel',
    },
    Corporate: {
      GoogleTag: 'env__tracking__corporate__google_tag',
      GoogleAnalyticsMeasurementId: 'env__tracking__corporate__google_analytics_measurement_id',
      MetaPixel: 'env__tracking__corporate__meta_pixel',
    },
    Maas: {
      GoogleTag: 'env__tracking__maas__google_tag',
      GoogleAnalyticsMeasurementId: 'env__tracking__maas__google_analytics_measurement_id',
      MetaPixel: 'env__tracking__maas__meta_pixel',
    },
  },
  Checkout: {
    NotePlaceholder: 'env__checkout__note_placeholder',
  },
};

export default env;
